// RFC 6266's two spellings, most specific first: the extended form carries a charset and
// percent-escapes, the quoted form may escape a quote with a backslash, and the bare form runs to
// the next parameter.
const EXTENDED = /filename\*\s*=\s*[^']*'[^']*'([^;]+)/i;
const QUOTED = /filename\s*=\s*"((?:[^"\\]|\\.)*)"/i;
const BARE = /filename\s*=\s*([^;]+)/i;

/**
 * What the server called the file it just handed over, or null when it did not say.
 *
 * Read rather than assumed, because the name is the answer to a question the client cannot ask:
 * a dossier opened in 2019 downloads as `cerere-2019-000042.txt` whatever year it is fetched in,
 * and only the row in the database knows that. The caller keeps a fallback for the null.
 *
 * The last path segment, always. A name is not a path — a browser ignores the directories in an
 * `a.download` anyway — but taking the segment here means nothing downstream has to wonder, and a
 * header that arrived through a proxy is not this app's to trust.
 */
export function fileNameFromDisposition(header: string | null | undefined): string | null {
  if (!header) return null;
  const extended = EXTENDED.exec(header);
  if (extended) return segment(decode(extended[1].trim()));
  const quoted = QUOTED.exec(header);
  if (quoted) return segment(quoted[1].replace(/\\(.)/g, '$1'));
  const bare = BARE.exec(header);
  return bare ? segment(bare[1].trim()) : null;
}

/** A name the sender escaped; left as it stands when it is not valid escaping. */
function decode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function segment(value: string): string | null {
  const name = value.split(/[\\/]/).pop()?.trim() ?? '';
  return name ? name : null;
}
